module.exports = __webpack_public_path__ + "img/fragile-inactive.016289eb.svg";